module.exports = __webpack_public_path__ + "img/choice03.9b17a5c8.png";